import { render } from "./App.vue?vue&type=template&id=4cfd6747"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4cfd6747&lang=scss"

import exportComponent from "/Users/Matt/projects/betherance/betherswap/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__